import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { IconProps } from './interface'

export const IconWrapper = styled.span<{ size?: number }>`
  display: flex;
  width: ${({ size }) => size || '1rem'};
  height: ${({ size }) => size || '1rem'};

  svg {
    width: 100%;
    height: 100%;
  }
`
const StyledImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`

export const Icon = forwardRef<HTMLImageElement, IconProps>((props, ref) => {
  const { icon, name, iconSize, ...rest } = props

  if (!!name) {
    const Icon = require(`../../../assets/icons/${name}.svg`)?.default

    if (!Icon) {
      return null
    }

    return (
      <IconWrapper size={iconSize}>
        <Icon {...rest} />
      </IconWrapper>
    )
  }

  if (typeof icon !== 'object') {
    return null
  }
  const { filename, alt, title } = icon

  return (
    <IconWrapper size={iconSize}>
      <StyledImage ref={ref} src={filename} alt={alt} title={title} />
    </IconWrapper>
  )
})
